import { Button } from '@honeyscience/honey-ui-toolkit';
import classnames from 'classnames';
import React, { ReactElement } from 'react';
import { createUseStyles } from 'react-jss';
import PageDetectorToggles from 'mockStores/components/pageDetectorToggles';
import { getQueryString } from 'mockStores/lib/utils';
import Header from './Header';

const useStyles = createUseStyles({
  cartInfo: {
    backgroundColor: '#fdfdfd',
    border: '1px solid #ddd',
    borderRadius: '3px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '16px',
  },
  cartSection: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '16px',
  },
  cartTotal: {
    fontWeight: '600',
    marginBottom: '0px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '40px',
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  contentSection: {
    flexBasis: '48%',
  },
  input: {
    border: '1px solid #ddd',
    borderRadius: '3px',
    height: '42px',
    padding: '8px',
    width: '100%',
  },
  inputGroup: {
    marginBottom: '16px',
    width: '100%',
  },
  inputGroupFlex: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  label: {
    marginBottom: '8px',
  },
  paymentInformation: {
    display: 'flex',
    flexDirection: 'column',
  },
  paymentInformationTitle: {
    marginBottom: '16px',
  },
});

type StoreProps = {
  button?: ReactElement;
  title?: string;
  description?: string;
};

function Store({ button, title, description }: StoreProps): ReactElement {
  const classes = useStyles();

  const totalPrice = parseFloat(getQueryString('cartValue', '100') as string);
  const tax = totalPrice * 0.1;
  const shipping = totalPrice * 0.05;
  const subtotal = totalPrice - tax - shipping;

  return (
    <div className={ classes.container }>
      <Header title={ title } description={ description } />
      <PageDetectorToggles />
      <div className={ classes.content }>
        <div className={ classnames(classes.contentSection, classes.cartInfo) }>
          <div>
            <div className={ classes.cartSection }>
              <div>Item Subtotal</div>
              <div id="subtotal">{ subtotal.toFixed(2) }</div>
            </div>
            <div className={ classes.cartSection }>
              <div>Shipping</div>
              <div id="shipping">{ shipping.toFixed(2) }</div>
            </div>
            <div className={ classes.cartSection }>
              <div>Tax</div>
              <div id="tax">{ tax.toFixed(2) }</div>
            </div>
          </div>
          <div id="cart-total" className={ classnames(classes.cartSection, classes.cartTotal) }>
            <div>Total</div>
            <div>{ totalPrice.toFixed(2) }</div>
          </div>
        </div>
        <div className={ classnames(classes.contentSection, classes.paymentInformation) }>
          <div className={ classnames('title4', classes.paymentInformationTitle) }>
            Payment information
          </div>
          <div className={ classes.inputGroup }>
            <div className={ classnames('label3', classes.label) }>
              Credit Card Number
            </div>
            <input id="credit-card-number" type="text" className={ classes.input } />
          </div>
          <div className={ classnames(classes.inputGroup, classes.inputGroupFlex) }>
            <div>
              <div className="label label3">CVC</div>
              <input type="text" className={ classes.input } />
            </div>
            <div>
              <div className="label label3">Exp. Date</div>
              <input type="text" className={ classes.input } />
            </div>
          </div>
          <Button className="order-button" copy="Place Order" buttonType="secondary" />
          { button }
        </div>
      </div>
    </div>
  );
}

Store.defaultProps = {
  button: null,
  description: '',
  title: 'Honey Checkout Mock Store',
};

export default Store;
